// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as PnmIntCreateLeadApiModel$PorterinFeature from "../../api-model/PnmIntCreateLeadApiModel.mjs";

function apiModelToState(model) {
  return {
          opp_external_id: model.opportunity.external_id
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(PnmIntCreateLeadApiModel$PorterinFeature.t_decode(json), "PnmIntCreateLeadEntityMapper.res");
  return {
          opp_external_id: model.opportunity.external_id
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
